import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { IssueTopicCard } from "./IssueTopicCard/IssueTopicCard";
var isL1 = function isL1(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.level) === 0;
};
var hideL1OtherNode = function hideL1OtherNode(parentNode) {
  return isL1(parentNode);
};
var hideFaireProgramsOtherNode = function hideFaireProgramsOtherNode(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) === "FairePrograms";
};
var hideVerifyAccountOtherNode = function hideVerifyAccountOtherNode(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) === "VerifyAccount";
};
var hideSettingsOtherNode = function hideSettingsOtherNode(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) === "Settings";
};
var hidePaymentsOtherNode = function hidePaymentsOtherNode(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) === "Payments";
};
var hideOtherNode = function hideOtherNode(parentNode) {
  return hideFaireProgramsOtherNode(parentNode) || hideVerifyAccountOtherNode(parentNode) || hideSettingsOtherNode(parentNode) || hidePaymentsOtherNode(parentNode);
};
var shouldDisplayIconOnOtherNode = function shouldDisplayIconOnOtherNode(parentNode) {
  return (parentNode === null || parentNode === void 0 ? void 0 : parentNode.level) === 0;
};
export var OtherIssueTopicCard = function OtherIssueTopicCard(_ref) {
  var otherNode = _ref.otherNode,
    selectedNode = _ref.selectedNode,
    parentNode = _ref.parentNode,
    _onClick = _ref.onClick,
    style = _ref.style;
  if (!otherNode) {
    return null;
  }
  if (hideL1OtherNode(parentNode)) {
    return null;
  }
  if (hideOtherNode(parentNode)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IssueTopicCard, {
    text: otherNode.label,
    isSelected: otherNode.id === (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.id),
    onClick: function onClick() {
      return _onClick(otherNode);
    },
    dataTestId: buildId(parentNode, otherNode),
    icon: shouldDisplayIconOnOtherNode(parentNode) ? otherNode.icon : undefined,
    style: _objectSpread({}, style)
  });
};
var buildId = function buildId(parentNode, otherNode) {
  var _parentNode$id;
  return "self-serve-node-".concat(otherNode.id).concat((_parentNode$id = parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) !== null && _parentNode$id !== void 0 ? _parentNode$id : "Root");
};